import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { fetchSeasonalNote } from "@/lib/api";

const SeasonalNote = () => {
  const [note, setNote] = useState(null);

  useEffect(() => {
    fetchSeasonalNote().then(setNote).catch(() => {});
  }, []);

  if (!note?.active) return null;

  return (
    <div data-testid="seasonal-note" className="bg-teal text-cream border-b border-gold/40">
      <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-center gap-2.5 text-center">
        <Sparkles size={15} className="text-gold shrink-0" aria-hidden="true" />
        <p className="text-sm md:text-base tracking-wide">
          <span className="font-display italic text-gold text-base md:text-lg">{note.title}</span>
          <span className="text-cream/90"> — {note.message}</span>
        </p>
        <Sparkles size={15} className="text-gold shrink-0" aria-hidden="true" />
      </div>
    </div>
  );
};

export default SeasonalNote;
